function n() {
  let e;
  const c = [];
  for (let t = 0; t < 256; t++) {
    e = t;
    for (let l = 0; l < 8; l++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    c[t] = e;
  }
  return c;
}
let r;
function o(e) {
  r = r || n();
  let c = -1;
  for (let t = 0; t < e.length; t++)
    c = c >>> 8 ^ r[(c ^ e.charCodeAt(t)) & 255];
  return ((c ^ -1) >>> 0).toString(16);
}
export {
  o as crc32,
  n as makeCRCTable
};
